module.exports = __webpack_public_path__ + "static/media/prime-logo-icon.58c3bfe7.jpg";